// ====== KEY_DASHBOARD ======
export const KEY_DASHBOARD = "DASHBOARD";
// ====== KEY_DASHBOARD ======

// ====== KEY_DEVICE_MANAGEMENT ======
// ====== KEY_DEVICE_MANAGEMENT_CUSTOMERS ======
export const KEY_DEVICE_MANAGEMENT = "DEVICE_MANAGEMENT";
export const KEY_DEVICE_MANAGEMENT_CUSTOMERS = "DEVICE_MANAGEMENT_CUSTOMERS";
export const KEY_DEVICE_MANAGEMENT_CUSTOMERS_ADD =
  "DEVICE_MANAGEMENT_CUSTOMERS_ADD";
export const KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE =
  "DEVICE_MANAGEMENT_CUSTOMERS_UPDATE";
export const KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE =
  "DEVICE_MANAGEMENT_CUSTOMERS_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_CUSTOMERS ======

// ====== KEY_DEVICE_MANAGEMENT_PROJECT ======
export const KEY_DEVICE_MANAGEMENT_PROJECT = "DEVICE_MANAGEMENT_PROJECT";
export const KEY_DEVICE_MANAGEMENT_PROJECT_ADD =
  "DEVICE_MANAGEMENT_PROJECT_ADD";
export const KEY_DEVICE_MANAGEMENT_PROJECT_UPDATE =
  "DEVICE_MANAGEMENT_PROJECT_UPDATE";
export const KEY_DEVICE_MANAGEMENT_PROJECT_DELETE =
  "DEVICE_MANAGEMENT_PROJECT_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_PROJECT ======

// ====== KEY_DEVICE_MANAGEMENT_BUILDINGS ======
export const KEY_DEVICE_MANAGEMENT_BUILDINGS = "DEVICE_MANAGEMENT_BUILDINGS";
export const KEY_DEVICE_MANAGEMENT_BUILDINGS_ADD =
  "DEVICE_MANAGEMENT_BUILDINGS_ADD";
export const KEY_DEVICE_MANAGEMENT_BUILDINGS_UPDATE =
  "DEVICE_MANAGEMENT_BUILDINGS_UPDATE";
export const KEY_DEVICE_MANAGEMENT_BUILDINGS_DELETE =
  "DEVICE_MANAGEMENT_BUILDINGS_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_BUILDINGS ======

// ====== KEY_DEVICE_MANAGEMENT_FLOORS ======
export const KEY_DEVICE_MANAGEMENT_FLOORS = "DEVICE_MANAGEMENT_FLOORS";
export const KEY_DEVICE_MANAGEMENT_FLOORS_ADD = "DEVICE_MANAGEMENT_FLOORS_ADD";
export const KEY_DEVICE_MANAGEMENT_FLOORS_UPDATE =
  "DEVICE_MANAGEMENT_FLOORS_UPDATE";
export const KEY_DEVICE_MANAGEMENT_FLOORS_DELETE =
  "DEVICE_MANAGEMENT_FLOORS_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_FLOORS ======

// ====== KEY_DEVICE_MANAGEMENT_DEVICES ======
export const KEY_DEVICE_MANAGEMENT_DEVICES = "DEVICE_MANAGEMENT_DEVICES";
export const KEY_DEVICE_MANAGEMENT_DEVICES_ADD =
  "DEVICE_MANAGEMENT_DEVICES_ADD";
export const KEY_DEVICE_MANAGEMENT_DEVICES_UPDATE =
  "DEVICE_MANAGEMENT_DEVICES_UPDATE";
export const KEY_DEVICE_MANAGEMENT_DEVICES_DELETE =
  "DEVICE_MANAGEMENT_DEVICES_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_DEVICES ======

// ====== KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS ======
export const KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS =
  "DEVICE_MANAGEMENT_DEVICE_GROUPS";
export const KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_ADD =
  "DEVICE_MANAGEMENT_DEVICE_GROUPS_ADD";
export const KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE =
  "DEVICE_MANAGEMENT_DEVICE_GROUPS_UPDATE";
export const KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE =
  "DEVICE_MANAGEMENT_DEVICE_GROUPS_DELETE";
// ====== KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS ======

// ====== KEY_DEVICE_MANAGEMENT ======

// ====== KEY_IMPORTANT ======
export const KEY_IMPORTANT = "IMPORTANT";
// ====== KEY_IMPORTANT ======

// ====== KEY_CAMPAIGNS ======
export const KEY_CAMPAIGNS = "CAMPAIGNS";
export const KEY_CAMPAIGNS_ADD = "CAMPAIGNS_ADD";
export const KEY_CAMPAIGNS_UPDATE = "CAMPAIGNS_UPDATE";
export const KEY_CAMPAIGNS_DELETE = "CAMPAIGNS_DELETE";
// ====== KEY_CAMPAIGNS ======

// ====== KEY_MEDIAS ======
export const KEY_MEDIAS = "MEDIAS";
export const KEY_MEDIAS_ADD = "MEDIAS_ADD";
export const KEY_MEDIAS_UPDATE = "MEDIAS_UPDATE";
export const KEY_MEDIAS_DELETE = "MEDIAS_DELETE";
// ====== KEY_CAMPAIGNS ======

export const KEY_MANAGEMENT = "MANAGEMENT";

// ====== KEY_REPORTS ======
export const KEY_REPORTS = "REPORTS";
export const KEY_REPORTS_ACTION_LOGS = "REPORTS_ACTION_LOGS";
export const KEY_REPORTS_MEDIA_LOGS = "REPORTS_MEDIA_LOGS";
export const KEY_REPORTS_SCREENSHOT = "REPORTS_SCREENSHOT";

export const KEY_REPORTS_MEDIA_LOGS_EXPORT_EXCEL =
  "REPORTS_MEDIA_LOGS_EXPORT_EXCEL";

// ====== KEY_REPORTS ======

// ====== KEY_USERS_MANAGEMENTS ======
export const KEY_USERS_MANAGEMENTS = "USERS_MANAGEMENTS";

// ====== KEY_USERS_MANAGEMENTS_ROLES ======
export const KEY_USERS_MANAGEMENTS_ROLES = "USERS_MANAGEMENTS_ROLES";
export const KEY_USERS_MANAGEMENTS_ROLES_ADD = "USERS_MANAGEMENTS_ROLES_ADD";
export const KEY_USERS_MANAGEMENTS_ROLES_UPDATE =
  "USERS_MANAGEMENTS_ROLES_UPDATE";
export const KEY_USERS_MANAGEMENTS_ROLES_DELETE =
  "USERS_MANAGEMENTS_ROLES_DELETE";
// ====== KEY_USERS_MANAGEMENTS_ROLES ======

// ====== KEY_USERS_MANAGEMENTS_USERS ======
export const KEY_USERS_MANAGEMENTS_USERS = "USERS_MANAGEMENTS_USERS";
export const KEY_USERS_MANAGEMENTS_USERS_ADD = "USERS_MANAGEMENTS_USERS_ADD";
export const KEY_USERS_MANAGEMENTS_USERS_UPDATE =
  "USERS_MANAGEMENTS_USERS_UPDATE";
export const KEY_USERS_MANAGEMENTS_USERS_DELETE =
  "USERS_MANAGEMENTS_USERS_DELETE";

export const KEY_USERS_MANAGEMENTS_USERS_LOCATION =
  "USERS_MANAGEMENTS_USERS_LOCATION";
// ====== KEY_USERS_MANAGEMENTS_USERS ======

// ====== KEY_USERS_MANAGEMENTS ======
